var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "cancel-with-box" }, [
    _c("div", { staticClass: "d-flex" }, [
      _c(
        "div",
        {
          staticClass:
            "d-flex align-items-center justify-content-between w-100",
        },
        [
          _c("div", { staticClass: "font-weight-bold" }, [
            _vm._v(_vm._s(_vm._f("trans")("Cancel Task"))),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text-muted" }, [
            _vm._v(_vm._s(_vm._f("trans")("No Credits will be charged"))),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "text-muted font-weight-bold" }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "cancel-btn-box" }, [
      _c(
        "div",
        {
          staticClass: "cancel-btn",
          on: {
            click: function ($event) {
              return _vm.cancelTask()
            },
          },
        },
        [
          _c("div", { staticClass: "cancel-btn-text" }, [
            _c("i", { staticClass: "far fa-times" }),
            _vm._v(" " + _vm._s(_vm._f("trans")("Cancel Task")) + "\n      "),
          ]),
          _vm._v(" "),
          _vm._m(0),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-none" }, [
      _c("i", { staticClass: "far fa-arrow-right" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }